/* eslint-disable no-useless-escape */
const REGEX = {
  EMAIL: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/,
  EMAIL_4: /^[\w-\.]+@([a-zA-Z]+\.)+[a-zA-Z]{2,4}$/, // only alphabets and dot(.) allowed after @
  CUSTOMER_NAME: /^[\s]*([A-Za-z]+)+(([\s])([A-Za-z]+))([\s]*)$/,
  TWO_THREE_WORD_NAME: /^[\s]*([A-Za-z]+)+(([\s])([A-Za-z]+)){1,2}([\s]*)$/,
  ONE_TO_FOUR_WORD_NAME: /^[\s]*([A-Za-z]+)+(([\s])([A-Za-z]+)){1,3}([\s]*)$/,
  CUSTOMER_SINGLENAME: /^[a-zA-Z]+[\s]*$/,
  DOB: /^([0-2][0-9]|(3)[0-1])(\/)(((0)[0-9])|((1)[0-2]))(\/)\d{4}$/,
  NOMINEE_DOB: /^[\d]{2}[\/]{1}[\d]{2}[\/]{1}[\d]{4}$/,
  NOMINEE_NAME: /[A-z][\s/][A-z]/,
  ASSIGNEE_NAME: /^([A-Za-z]+)+(([\s])([A-Za-z]+)){1,3}$/,
  MOBILE_NUMBER: /^[6-9][0-9]{9}$/,
  PHONE: /^\d{10}$/,
  REGISTRATION_NUMBER: /^(([A-Za-z]){2}[0-9]{1,2}[A-Za-z]{1,3}([0-9]){4})$/g,
  REGISTRATION_NUMBER_WITHOUT_G:
    /^(([A-Za-z]){2}[0-9]{1,2}[A-Za-z]{1,3}([0-9]){4})$/, // separate regex to stop toggling behaviour
  ENGINE_NUMBER: /^[a-zA-Z0-9]{6,30}$/,
  CHASSIS_NUMBER: /^[a-zA-Z0-9]{6,17}$/,
  CHASSIS_NUMBER_NEW: /^[a-zA-Z0-9]{17}$/,
  CHASSIS_NUMBER_V2: /^[a-zA-Z0-9]{6,30}$/,
  POLICY_NUMBER:
    /^(?![-\/])(?!.*(--|\/\/|-\/|\/-|:| ))^[\a-zA-Z0-9\-\/]{1,50}(?!_)(?:[a-zA-z0-9])$/,
  PREV_POLICY_NUMBER:
    /^(?![-\/])(?!.*(--|\/\/|-\/|\/-|:| ))^[\a-zA-Z0-9\-\/]{4,50}(?!_)(?:[a-zA-z0-9])$/,
  PAY_AMT: /\B(?=(\d{3})+(?!\d))/g,
  PAN: /^[a-zA-Z]{5}\d{4}[a-zA-Z]{1}$/,
  AADHAR: /^\d{12}$/,
  PINCODE: /^\d{6}$/,
  TEN_DIGIT_NUMBER: /^[\d]+/g,
  TEN_DIGIT_NUMBER_2: /^[0-9]{10}$/,
  NON_MANDATORY_TEN_DIGIT: /^(?:[6-9][0-9]{9}|)$/,

  REGISTRATION_NUMBER_2: /^([A-Za-z]{2}[0-9]{1}[A-Za-z]{1}[0-9]{4})/,
  REGISTRATION_NUMBER_3_G:
    /^([A-Za-z]{2}[\s][0-9]{1,2}[\s][A-Za-z]{1,3}[\s][0-9])$/g,

  REGISTRATION_NUMBER_WITHOUT_SPACES:
    /^(([A-Za-z]){2}[\s][0-9]{1,2}[\s][A-Za-z]{1,3}[\s]([0-9]){4})$/,

  REGISTRATION_NUMBER_PATTERN_1: /^([A-Za-z]{2}[\s][0-9]{1}[A-Za-z]{1,3})/g,
  REGISTRATION_NUMBER_PATTERN_2: /^([A-Za-z]{2}[\s][0-9]{2}[A-Za-z]{1,3})/g,
  REGISTRATION_NUMBER_PATTERN_3: /^([A-Za-z]{2}[\s][0-9]{1}[\s][A-Za-z]{1,3})/g,
  REGISTRATION_NUMBER_PATTERN_4: /^([A-Za-z]{2}[\s][0-9]{2}[\s][A-Za-z]{1,3})/g,
  REGISTRATION_NUMBER_PATTERN_5:
    /^([A-Za-z]{2}[\s][0-9]{1,2}[\s][A-Za-z]{1}[0-9])/g,
  REGISTRATION_NUMBER_PATTERN_6:
    /^([A-Za-z]{2}[\s][0-9]{1,2}[\s][A-Za-z]{2}[0-9])/g,
  REGISTRATION_NUMBER_PATTERN_7:
    /^([A-Za-z]{2}[\s][0-9]{1,2}[\s][A-Za-z]{3}[0-9])/g,
  REGISTRATION_NUMBER_PATTERN_8:
    /^([A-Za-z]{2}[\s][0-9]{1,2}[\s][A-Za-z]{1}[\s][0-9])/g,
  REGISTRATION_NUMBER_PATTERN_9:
    /^([A-Za-z]{2}[\s][0-9]{1,2}[\s][A-Za-z]{2}[\s][0-9])/g,
  REGISTRATION_NUMBER_PATTERN_10:
    /^([A-Za-z]{2}[\s][0-9]{1,2}[\s][A-Za-z]{3}[\s][0-9])/g,

  EMAIL_2:
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/, // editOTPSave 265 //inputSave 114
  TEXT_WITH_SPACES: /[A-Za-z\s]/,
  ALPHANUMERIC_WITH_HYPHEN: /[A-Za-z0-9/-]/,
  ALPHANUMERIC: /[A-Za-z0-9]/,
  ALPHANUMERIC_2: /^[a-zA-Z0-9]*$/,
  DOB_2: /^[\d\/]+/g,

  PANCARD_REGEX: /^[a-zA-Z]{3}[p|P][a-zA-Z][0-9]{4}[a-zA-Z]$/,
  PAN_REGEX: /[A-Z]{5}[0-9]{4}[A-Z]{1}/,
  AADHAR_REGEX: /^\d{12}$/,
  CKYCNUMBER_REGEX: /^\d{14}$/,
  PASSPORT_REGEX: /^([a-zA-Z]){1}([0-9]){7}$/,
  VOTERID_REGEX: /^([a-zA-Z]){3}([0-9]){7}?$/,
  DL_REGEX: /^[a-zA-Z0-9\/-]*$/,
  WORDS_N_SPACES: /\w\S*/g,
  HEIGHT_INCH: /^((\d)|([0-1][0-1]))?[\"]?$/,
  HEIGHT_FEET: /^[1-8]{1}$/,
  WEIGHT: /^(?!0+$)\d+$/,

  ALPHANUMERIC_WITH_HYPHEN_BACKSLASH: /[A-Za-z0-9/\\-]/,
  EMAIL_3: /^[\w+\.?\w+]{1,64}@\w+\.\w+$/,
  ALPHABETS_WITH_SPACES: /^[a-zA-Z ]+$/,
  ALPHABETS_WITH_SPACES_AND_QUOTES: /^[a-zA-Z' ]+$/,
  TIME: /^(1[012]|0[1-9]):[0-5][0-9]\s?(am|pm)$/i,
  ALPHANUMERIC_WITH_SPACES: /[A-Za-z0-9\s]/,
  CLAIM_REGISTER_POLICY_NUMBER: /^[0-9a-zA-Z]{6,20}$/,
  CLAIM_REGISTER_PHONE_NO: /^[0-9]{1,15}$/,
  FREE_TEXT: '[A-Za-z0-9\\s.\\"\\\\@/|#&\'$-:\\]\\[,]',
  FREE_TEXT_2: /^.*$/,
  location: /^[a-zA-Z0-9][a-zA-Z0-9, ]*$/,
  FREE_TEXT3: /^[a-zA-Z0-9 \/\-\,\\]*$/,
  RENEWAL_NOMINEE_NAME: /[a-zA-Z][\s/][a-zA-Z]/,
  FREE_TEXT4: /^(?!.*[\/\\,\-]{2}).*$/,

  //   ATLEAST_1_LETTER_1_DIGIT: /([A-Za-z]+[0-9]|[0-9]+[A-Za-z])[A-Za-z0-9]*/, // Atleast 1 letter and 1 digit
  ATLEAST_1_LETTER_1_DIGIT: /^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9]+)$/, // Atleast 1 letter and 1 digit
  ALL_ZEROS: /^0+$/,
  POLICY_NUMBER_SPECIAL_CHARACTERS: /[/_\-\s]/g,
  MULTIPLE_SPACES: /\s+/g,
  WHITESPACES: /\s/g,
  REMOVETITLE: /(MR|MS)\s/g,
  DIAGNOSIS_DATE: /([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/,
};

const a = '';

export { REGEX, a };
